/* eslint-disable */
const http = {
    https: '/ocenter/public/index.php/admin',
    http: '/ocenter/'
}
export default http